/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000, // Set animation duration as per your animation
};

const greeting = {
  username: "Simon Kobler",
  title: "Hello everyone, I'm Simon Kobler",
  subTitle: emoji(
    "A Senior Software Developer 🚀 with extensive experience in cloud platforms (especially Azure, AWS and GCP) and automation tools (GitHub, GitLab & Jenkins). I also have a strong background in building web and mobile applications using JavaScript, Ionic, Node.js, Angular, and other modern libraries and frameworks."
  ),
  resumeLink: "", // Set to empty to hide the button
  displayGreeting: true, // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/KoblerS",
  linkedin: "https://www.linkedin.com/in/simon-kobler/",
  gmail: "portfolio@kobler.me",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true, // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "DEVOPS SOLUTION ARCHITECT WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji("⚡ Architect and develop automation and robust cloud solutions"),
    emoji(
      "⚡ Full-Stack development using frameworks such as Angular, Ionic and Node.js, Python or Java & Spring Boot"
    ),
    emoji(
      "⚡ Integration of third party services such as Azure / AWS / GCP & Firebase"
    ),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws",
    },
    {
      skillName: "azure",
      fontAwesomeClassname: "fab fa-microsoft",
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire",
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js",
    },
    {
      skillName: "node.js",
      fontAwesomeClassname: "fab fa-node",
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python",
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java",
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift",
    },
    {
      skillName: "html",
      fontAwesomeClassname: "fa fa-code",
    },
    {
      skillName: "css",
      fontAwesomeClassname: "fab fa-css3-alt",
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass",
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database",
    },
    {
      skillName: "mongodb",
      fontAwesomeClassname: "fas fa-database",
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker",
    },
    {
      skillName: "ansible",
      fontAwesomeClassname: "fas fa-server",
    },
    {
      skillName: "jenkins",
      fontAwesomeClassname: "fab fa-jenkins",
    },
    {
      skillName: "GitHub Actions",
      fontAwesomeClassname: "fab fa-github",
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName:
        "Chamber of Commerce and Industry for Munich and Upper Bavaria (CCI)",
      logo: require("./assets/images/munich.webp"),
      subHeader: "Apprenticeship in IT Management",
      duration: "September 2016 - July 2019",
      desc: "",
      descBullets: [],
    },
  ],
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "backend", //Insert stack or technology you have experience in
      progressPercentage: "100%", //Insert relative proficiency in percentage
    },
    {
      Stack: "frontend",
      progressPercentage: "90%",
    },
    {
      Stack: "app development",
      progressPercentage: "60%",
    },
  ],
  displayCodersrank: false, // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior Software Developer",
      company: "SAP SE",
      companylogo: require("./assets/images/sap.webp"),
      date: "Sep 2025 – Present",
      desc: "",
      descBullets: [
        "Working as a Senior Software Developer in the CAP (Cloud Application Programming Model) team",
        "Focus on development and maintenance of Node.js plugins integrating CAP into SAP BTP (Business Technology Platform)",
        "Designing, implementing, and optimizing extensibility features and developer tooling",
        "Enhancing integration workflows to improve developer experience and platform capabilities",
      ],
    },
    {
      role: "DevOps Solution Architect",
      company: "W. L. Gore & Associates GmbH",
      companylogo: require("./assets/images/gore.webp"),
      date: "Dec 2023 – Sep 2025",
      desc: "",
      descBullets: [
        "Project responsibility for implementation and migration to GitHub for over 200 developers",
        "Developed scalable analytics infrastructure with Azure Databricks and Azure Data Lake",
        "Designed and implemented multiple Azure Landing Zones",
        "Automated CI/CD and release management with GitHub Actions",
        "Created GitHub template repositories for efficient onboarding",
        "Optimized costs and enabled automatic scaling of infrastructure using REST APIs",
      ],
    },
    {
      role: "Senior DevOps Developer",
      company: "W. L. Gore & Associates GmbH",
      companylogo: require("./assets/images/gore.webp"),
      date: "May 2020 – Dec 2023",
      desc: "",
      descBullets: [
        "Technical Lead and main point of contact in DevOps",
        "Installed and supported 15+ Kubernetes clusters using AWS EKS (Traefik & NGINX)",
        "Delivered 'Configuration as Code' and 'Infrastructure as Code' with AWS CloudFormation (ACM, CloudFront, DynamoDB, EKS, EC2, IAM, Lambda 'SAM', Route53, S3, SSM)",
        "Created centralized authentication platform for static web apps and AWS Lambda functions with OpenID 2.0 - OIDC authentication",
      ],
    },
    {
      role: "Full-Stack Software Developer",
      company: "W. L. Gore & Associates GmbH",
      companylogo: require("./assets/images/gore.webp"),
      date: "Jul 2019 – May 2020",
      desc: "",
      descBullets: [
        "Developed custom internal and external web applications using Java, Node.js & TypeScript, or Python",
        "Developed unit and end-to-end (E2E) tests using frameworks such as JUnit, Cypress, Mocha, or PyTest",
      ],
    },
  ],
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: true, // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I DEVELOPED THEIR TECH STACK",
  projects: [
    {
      image: require("./assets/images/befundo.webp"),
      imageDark: require("./assets/images/befundo-dark.webp"),
      projectName: "Befundo",
      projectDesc:
        "App to analyse and explain medical lab results for patients in Germany",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://befundo.app/",
        },
        {
          name: "Download App",
          url: "https://get.befundo.app/",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: require("./assets/images/vehar-logistik.webp"),
      imageDark: require("./assets/images/vehar-logistik-dark.webp"),
      projectName: "Vehar Logistik",
      projectDesc:
        "Logistics platform for the transport of goods in Germany and Europe",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://vehar-logistik.de/",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: require("./assets/images/avegoo.webp"),
      imageDark: require("./assets/images/avegoo-dark.webp"),
      projectName: "Avegoo",
      projectDesc:
        "Coworking workspace platform to find and book workspaces all around Germany",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://app.avegoo.de/",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: require("./assets/images/databos.webp"),
      imageDark: require("./assets/images/databos-dark.webp"),
      projectName: "DataBOS",
      projectDesc:
        "German authorities management platform responsible for the public safety sector",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://databos.de/",
        },
      ],
    },
    {
      image: require("./assets/images/tischgaudi.webp"),
      imageDark: require("./assets/images/tischgaudi.webp"),
      projectName: "Tischgaudi",
      projectDesc:
        "Social media application for festivals in Germany such as the Oktoberfest to gain table reservations and find new friends",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.tischgaudi.de/en/home",
        },
      ],
    },
    {
      image: require("./assets/images/schilderexpress.webp"),
      imageDark: require("./assets/images/schilderexpress-dark.webp"),
      projectName: "Schilderexpress",
      projectDesc: "Online webshop for license plate production in Germany",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.schilderexpress.eu",
        },
      ],
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle: "Award Letters that I've won !",

  achievementsCards: [
    {
      title: "Germanys best Developer",
      subtitle:
        "I've got certified as Germanys best developer 2018, honored by WorldSkills Germany.",
      image: require("./assets/images/worldskills.webp"),
      imageDark: require("./assets/images/worldskills-dark.webp"),
      imageAlt: "WorldSkills Logo",
      footerLink: [
        {
          name: "Read more",
          url: "https://www.mittelstandcafe.de/simon-kobler-ist-deutschlands-bester-it-softwareentwickler-1673778.html",
        },
      ],
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle: "",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [],
  display: false, // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/",
    },
  ],
  display: false, // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo",
  ],
  display: false, // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false, // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "",
  email_address: "portfolio@kobler.me",
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false, // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
};
